'use strict';

var Sugar = require('sugar-core'),
    _dateOptions = require('./var/_dateOptions');

module.exports = Sugar.Date.getOption;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/getOption.js
// module id = 188
// module chunks = 1